<template>
    <div>
      <div class="row col-12" style="padding: 10px;">
        <div class="col-6" style="font-weight: bold;">
          Broadcast Announcement Message
        </div>
        <div class="col-6">
          <div class="row col-12">
            <div class="col-2" style="font-weight: bold;">Status: </div>
            <div class="col-9 row">
              <div>ON</div>&nbsp;
              <label class="switch switch-3d switch-danger" style="margin-bottom: 0">
                <input v-model="isDraft" v-on:change="toogleDraft()" type="checkbox" class="switch-input">
                <span class="switch-label"></span>
                <span class="switch-handle"></span>
              </label>&nbsp;
              <div>OFF</div>
            </div>
          </div>
        </div>
      </div>
        <div class="row">
            <div class="col-xl-12">
                <vue-editor id="editor" v-model="htmlForEditor"> </vue-editor>
            </div>
        </div>
        
        <div class="row" style="padding-top: 20px;padding-right: 15px;">
            <div class="col-xl-6">
              <table class="table table-bordered table-striped table-sm table-text-no-wrap">
                <tbody>
                  <tr>
                    <td class="align-middle text-center">
                      <div>E-mail notification to users</div>
                      <!-- <strong>{{ isChecked === true ? 'send' : "Don't send" }}</strong> -->
                    </td>
                    <td class="align-middle text-center">
                      <input style="padding: 15px;" type="checkbox" v-model="isChecked" @change="handleChangeCheck">
                    </td>  
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div class="row" style="padding: 15px;">
              <div>State: <strong>{{ isChecked }}</strong></div>
              <input style="padding: 15px;" type="checkbox" v-model="isChecked" @change="handleChangeCheck">
            </div> -->
            <div class="ml-auto">
                <button v-on:click="previewAccouncement()" type="button" class="btn btn-primary px-4">Preview Announcement</button>
                <button v-on:click="saveHtml()" type="button" class="btn btn-primary px-4">Save</button>
            </div>
        </div>
      
      <b-modal title="Preview Announcement - Metal Market" class="modal-primary" ok-only size="lg" v-model="checkPreviewAnnouncement" @ok="closePreviewAnnouncement()">
        <div class="row">
          <div class="col-12">
            <h6>Preview New Updates</h6>
            <br/>
            <table class="table table-bordered table-striped table-sm">
              <tbody>
                <tr>
                  <td>
                    <div class="ql-editor" v-html='htmlForEditor'>
                    </div>
                  </td>  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-modal>
      <announcement></announcement>
    </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { Announcement } from '../../components/'
export default {
  name: 'Setting',
  data () {
    return {
      htmlForEditor: '',
      isChecked: false,
      isDraft: false,
      checkPreviewAnnouncement: false
    }
  },
  methods: {
    saveHtml () {
      this.$toasted.show('Saved announcement', {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 500
      })
      console.log('saveHtml -> htmlForEditor', this.htmlForEditor)
      this.$http.post('order/saveHtml', {'content': this.htmlForEditor, 'mailOnEdit': this.isChecked, 'isDraft': this.isDraft}).then(response => {
        console.log('saveHtml -> response', response)
      }, response => {
        console.log(response)
      })
    },
    handleChangeCheck () {
      console.log('handleChangeCheck -> this.isChecked', this.isChecked)
    },
    getAnnouncementDetails () {
      this.$http.get('admin/announcement-content').then(response => {
        this.htmlForEditor = response.body[0]['setting_value']
        this.isDraft = parseInt(response.body[1]['setting_value'])
        this.isChecked = parseInt(response.body[2]['setting_value'])
      }, response => {
        console.log(response)
      })
    },
    toogleDraft () {
    },
    closePreviewAnnouncement () {
      this.checkPreviewAnnouncement = false
    },
    previewAccouncement () {
      this.checkPreviewAnnouncement = true
    }
  },
  beforeMount () {
    this.getAnnouncementDetails()
  },
  components: {
    VueEditor,
    Announcement
  }
}
</script>

<style>
  .error-text {
    color: red;
  }
  .success-text {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/Setting.vue